import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Title = styled.h1`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.title)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.title)}
`;
